module.exports = __webpack_public_path__ + "img/connect-1.672c8ce4.svg";